export enum Role {
  ECS = 'ECS',
  NC = 'NC',
}
